var _defs, _rect, _g, _g2, _rect2, _rect3, _rect4, _tspan, _tspan2, _circle, _g3, _rect5, _rect6, _tspan3, _tspan4, _tspan5, _rect7, _rect8, _tspan6, _tspan7, _tspan8, _rect9, _rect0, _tspan9, _tspan0, _tspan1, _rect1, _rect10, _tspan10, _tspan11, _tspan12, _g4, _rect11, _rect12, _tspan13, _rect13, _tspan14, _g5, _tspan15, _rect14, _rect15, _g6, _tspan16, _rect16, _rect17, _tspan17, _tspan18, _g7, _tspan19, _g8, _tspan20, _rect18, _tspan21, _tspan22, _rect19, _rect20, _tspan23, _tspan24, _rect21, _rect22, _tspan25, _tspan26, _tspan27, _g9, _tspan28, _g0, _rect23, _rect24, _tspan29, _tspan30, _rect25, _tspan31, _path, _rect26, _tspan32, _rect27, _tspan33, _tspan34, _rect28, _tspan35, _path2, _rect29, _tspan36, _g1, _tspan37, _g10, _g11, _rect30, _rect31, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _rect32, _rect33, _rect34, _tspan47, _g12, _tspan48, _g13, _g14, _tspan49, _rect35, _tspan50, _g15, _rect36, _tspan51, _g16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 472,
    height: 312,
    viewBox: "0 0 472 312",
    fill: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 312,
    rx: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_11512_2147_f3",
    x: 489.7,
    y: 2505.7,
    width: 349.6,
    height: 349.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_11512_2147_f3",
    x: 134.7,
    y: 2261.7,
    width: 288.6,
    height: 288.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_11512_2147_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 2415,
    width: 660.92,
    height: 399,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_11512_2147_f3",
    x: 438.463,
    y: 2697.33,
    width: 19.6661,
    height: 19.7496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_11512_2147_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 2391,
    width: 472,
    height: 312,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11512_2147_f3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(284.294 2475.79) rotate(90) scale(19.5828 19.5828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.747759,
    stopColor: "#44B50F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87771,
    stopColor: "#56D01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_i_11512_2147_f3",
    x: 205,
    y: 2389,
    width: 474,
    height: 314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.29293 0 0 0 0 0.353365 0 0 0 0 0.257379 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_11512_2147_f3",
    x: 241.688,
    y: 2427.69,
    width: 595.485,
    height: 88.2896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_11512_2147_f3",
    x: 435.464,
    y: 2672.85,
    width: 71.0717,
    height: 33.0717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.38397
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.76793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_11512_2147_f3",
    x: 391,
    y: 2598,
    width: 161,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_11512_2147_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.97552,
    height: 7.97552,
    fill: "white",
    transform: "translate(522.024 2639)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_11512_2147_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.97552,
    height: 7.97552,
    fill: "white",
    transform: "translate(522.024 2658.98)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_11512_2147_f3",
    x: 349,
    y: 2556,
    width: 245,
    height: 211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.449829 0 0 0 0 0.577083 0 0 0 0 0.370295 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_11512_2147_f3",
    x: 483,
    y: 2695,
    width: 21,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame_f3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207 -2391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 782_3_f3",
    filter: "url(#filter34_i_11512_2147_f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_11512_2147_f3)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 2391,
    width: 472,
    height: 312,
    rx: 24,
    fill: "#17270D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1_4_f3",
    opacity: 0.38,
    filter: "url(#filter35_f_11512_2147_f3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 2406,
    r: 53,
    fill: "#43B017"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2_3_f3",
    opacity: 0.24,
    filter: "url(#filter36_f_11512_2147_f3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 664.5,
    cy: 2680.5,
    r: 83.5,
    fill: "#43B017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "flip_financing_f3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_11512_2147_f3)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 2415,
    width: 660.92,
    height: 399,
    rx: 10,
    fill: "#F4FAEF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 395_f3",
    filter: "url(#filter37_d_11512_2147_f3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "investment-score_f3"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 245.932,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 245.932,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 296_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Deal Score_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 268.793,
    y: 2450.44
  }, "Deal Score"))), /*#__PURE__*/React.createElement("g", {
    id: "Group 19_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "70_f3",
    fill: "#43B017",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 15.6663,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 274.97,
    y: 2481.27
  }, "70"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4_f3",
    cx: 283.868,
    cy: 2475.79,
    r: 17.4543,
    stroke: "#EDF3E9",
    strokeWidth: 1.95828
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3_f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.294 2458.29C284.294 2457.14 285.229 2456.2 286.373 2456.32C289.259 2456.63 292.05 2457.57 294.538 2459.1C297.62 2460.99 300.118 2463.7 301.755 2466.93C303.392 2470.15 304.104 2473.77 303.812 2477.37C303.521 2480.98 302.236 2484.43 300.101 2487.35C297.967 2490.27 295.066 2492.54 291.719 2493.91C288.373 2495.28 284.712 2495.7 281.142 2495.12C277.573 2494.54 274.234 2492.98 271.497 2490.61C269.287 2488.71 267.538 2486.33 266.369 2483.68C265.906 2482.62 266.522 2481.45 267.618 2481.1C268.714 2480.75 269.873 2481.36 270.366 2482.4C271.282 2484.33 272.592 2486.06 274.219 2487.46C276.374 2489.32 279.003 2490.55 281.813 2491.01C284.623 2491.46 287.505 2491.14 290.139 2490.06C292.774 2488.98 295.058 2487.19 296.739 2484.89C298.419 2482.59 299.43 2479.87 299.66 2477.04C299.89 2474.2 299.329 2471.35 298.041 2468.81C296.752 2466.27 294.785 2464.14 292.359 2462.65C290.526 2461.53 288.486 2460.8 286.37 2460.51C285.23 2460.36 284.294 2459.44 284.294 2458.29Z",
    fill: "url(#paint1_radial_11512_2147_f3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.294 2458.29C284.294 2457.14 285.229 2456.2 286.373 2456.32C289.259 2456.63 292.05 2457.57 294.538 2459.1C297.62 2460.99 300.118 2463.7 301.755 2466.93C303.392 2470.15 304.104 2473.77 303.812 2477.37C303.521 2480.98 302.236 2484.43 300.101 2487.35C297.967 2490.27 295.066 2492.54 291.719 2493.91C288.373 2495.28 284.712 2495.7 281.142 2495.12C277.573 2494.54 274.234 2492.98 271.497 2490.61C269.287 2488.71 267.538 2486.33 266.369 2483.68C265.906 2482.62 266.522 2481.45 267.618 2481.1C268.714 2480.75 269.873 2481.36 270.366 2482.4C271.282 2484.33 272.592 2486.06 274.219 2487.46C276.374 2489.32 279.003 2490.55 281.813 2491.01C284.623 2491.46 287.505 2491.14 290.139 2490.06C292.774 2488.98 295.058 2487.19 296.739 2484.89C298.419 2482.59 299.43 2479.87 299.66 2477.04C299.89 2474.2 299.329 2471.35 298.041 2468.81C296.752 2466.27 294.785 2464.14 292.359 2462.65C290.526 2461.53 288.486 2460.8 286.37 2460.51C285.23 2460.36 284.294 2459.44 284.294 2458.29Z",
    fill: "#43B017"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "overview_f3"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 330.978,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 330.978,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 296_2_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Net Profit_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 354.839,
    y: 2462.02
  }, "Net Profit"))), /*#__PURE__*/React.createElement("g", {
    id: "$36.1K_f3"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 15.6663,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 352.299,
    y: 2481.11
  }, "36.1K"))), /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 11.7497,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 345.839,
    y: 2481.11
  }, "$")))))), /*#__PURE__*/React.createElement("g", {
    id: "overview_2_f3"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 416.023,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 416.023,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 296_3_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Total Project Cost_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 428.385,
    y: 2462.02
  }, "Total Project Cost"))), /*#__PURE__*/React.createElement("g", {
    id: "$89K_f3"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 15.6663,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 442.345,
    y: 2481.11
  }, "89K"))), /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 11.7497,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 435.885,
    y: 2481.11
  }, "$")))))), /*#__PURE__*/React.createElement("g", {
    id: "overview_3_f3"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 501.069,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 501.069,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 296_4_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ROI_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 533.93,
    y: 2462.02
  }, "ROI"))), /*#__PURE__*/React.createElement("g", {
    id: "10%_f3"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 11.7497,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 542.82,
    y: 2481.11
  }, "%"))), /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 15.6663,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 525.93,
    y: 2481.11
  }, "10")))))), /*#__PURE__*/React.createElement("g", {
    id: "overview_4_f3"
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 586.114,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 586.114,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 296_5_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ROI (Ann.)_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.475,
    y: 2462.02
  }, "ROI (Ann.)"))), /*#__PURE__*/React.createElement("g", {
    id: "31%_f3"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 15.6663,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 611.475,
    y: 2481.11
  }, "31"))), /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 11.7497,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 626.927,
    y: 2481.11
  }, "%")))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "overview_5_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 671.159,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.159,
    y: 2429.93,
    width: 76.7227,
    height: 79.8,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scenario_f3"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 245.932,
    y: 2518.05,
    width: 99.3828,
    height: 99.6331,
    rx: 3.67178,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 245.932,
    y: 2518.05,
    width: 99.3828,
    height: 99.6331,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 327_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Cash Scenario_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.437,
    y: 2535.62
  }, "Cash Scenario")))), /*#__PURE__*/React.createElement("g", {
    id: "input_2_f3"
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 253.521,
    y: 2543.27,
    width: 84,
    height: 15.6663,
    rx: 1.95828,
    fill: "#EEFBE7"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Loan Scenario_f3",
    fill: "#43B017",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.437,
    y: 2553.24
  }, "Loan Scenario"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "codex:check_7_f3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6_f3",
    d: "M327.24 2551.12L328.947 2553.03C328.956 2553.04 328.967 2553.04 328.98 2553.05C328.992 2553.06 329.006 2553.06 329.02 2553.06C329.033 2553.06 329.047 2553.06 329.059 2553.05C329.072 2553.04 329.083 2553.04 329.092 2553.03L332.135 2549.63",
    stroke: "#43B017",
    strokeWidth: 0.489571,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "input_3_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "BRRRR Scenario_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.437,
    y: 2570.87
  }, "BRRRR Scenario"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 335_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn_2_f3"
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 253.765,
    y: 2586.59,
    width: 83.7166,
    height: 19.3436,
    rx: 9.67178,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 253.765,
    y: 2586.59,
    width: 83.7166,
    height: 19.3436,
    rx: 9.67178,
    stroke: "#43B017",
    strokeWidth: 0.489571
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 236_f3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 7_f3",
    d: "M273.654 2594.31V2598.22",
    stroke: "#43B017",
    strokeWidth: 0.489571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8_f3",
    d: "M275.615 2596.26H271.698",
    stroke: "#43B017",
    strokeWidth: 0.489571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "New Scenario_f3",
    fill: "#43B017",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 278.839,
    y: 2598.37
  }, "New Scenario")))))), /*#__PURE__*/React.createElement("g", {
    id: "financing-expanded_f3"
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 353.635,
    y: 2518.05,
    width: 231.567,
    height: 266.254,
    rx: 3.67178,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 353.635,
    y: 2518.05,
    width: 231.567,
    height: 266.254,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 310_3_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 337_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Loan Costs_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.83313,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2536.09
  }, "Loan Costs")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 422_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "$9,050_f3",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.83313,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 524.198,
    y: 2536.09
  }, "$9,050"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "expand_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 558.031,
    y: 2525.64,
    width: 15.6663,
    height: 15.6663,
    rx: 7.83313,
    fill: "#E7F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6_f3",
    d: "M568.312 2534.94L565.865 2532.49L563.417 2534.94",
    stroke: "#17270D",
    strokeWidth: 0.489571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 401_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 400_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 397_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_2_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Terms_f3",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2555.29
  }, "Terms")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 399_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_4_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.864,
    y: 2545.31,
    width: 20,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "input_5_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.781,
    y: 2545.31,
    width: 21.9166,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 396_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Loan Amount_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2571.03
  }, "Loan Amount"))), /*#__PURE__*/React.createElement("g", {
    id: "input_6_f3"
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 530.615,
    y: 2561.06,
    width: 43.0822,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "280,300_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 544.781,
    y: 2571.03
  }, "280,300"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 396_2_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Down Payment_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2590.62
  }, "Down Payment"))), /*#__PURE__*/React.createElement("g", {
    id: "input_7_f3"
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 530.86,
    y: 2580.89,
    width: 42.5926,
    height: 15.1767,
    rx: 1.7135,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 530.86,
    y: 2580.89,
    width: 42.5926,
    height: 15.1767,
    rx: 1.7135,
    stroke: "#CBDCC3",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("text", {
    id: "14,000_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 548.781,
    y: 2590.62
  }, "14,000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 396_3_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Rehab Financing %_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2610.2
  }, "Rehab Financing %"))), /*#__PURE__*/React.createElement("g", {
    id: "input_8_f3"
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 530.86,
    y: 2600.47,
    width: 42.5926,
    height: 15.1767,
    rx: 1.7135,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 530.86,
    y: 2600.47,
    width: 42.5926,
    height: 15.1767,
    rx: 1.7135,
    stroke: "#CBDCC3",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("text", {
    id: "100%_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 553.781,
    y: 2610.2
  }, "100%"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 396_4_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_3_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Interest_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2629.78
  }, "Interest"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 341_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Non-Dutch_f3",
    fill: "#A3A3A3",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.85399,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 392.057,
    y: 2629.91
  }, "Non-Dutch"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "slider_f3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 796_f3",
    cx: 433.932,
    cy: 2627.64,
    r: 3.91656,
    fill: "#E7F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6_2_f3",
    d: "M432.464 2627.15L433.933 2628.62L435.402 2627.15",
    stroke: "#646262",
    strokeWidth: 0.489571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 342_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Non-Dutch_2_f3",
    fill: "#A3A3A3",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.85399,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 482.865,
    y: 2629.91
  }, "Non-Dutch"))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "slider_2_f3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 796_2_f3",
    cx: 524.74,
    cy: 2627.64,
    r: 3.91656,
    fill: "#E7F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6_3_f3",
    d: "M523.273 2627.15L524.742 2628.62L526.21 2627.15",
    stroke: "#646262",
    strokeWidth: 0.489571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "input_9_f3"
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 530.86,
    y: 2620.05,
    width: 42.5926,
    height: 15.1767,
    rx: 1.7135,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 530.86,
    y: 2620.05,
    width: 42.5926,
    height: 15.1767,
    rx: 1.7135,
    stroke: "#CBDCC3",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("text", {
    id: "10%_2_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 557.781,
    y: 2629.78
  }, "10%")))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 396_5_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_4_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Origination Fee_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2649.37
  }, "Origination Fee")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 399_2_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_10_f3"
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 476.949,
    y: 2639.39,
    width: 20,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "91.10%_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.949,
    y: 2649.37
  }, "91.10%")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 2_f3",
    d: "M500.865 2643.31V2651.14",
    stroke: "#CBDCC3",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "input_11_f3"
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 504.782,
    y: 2639.39,
    width: 21.9166,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "74.9%_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 504.782,
    y: 2649.37
  }, "74.9%")))), /*#__PURE__*/React.createElement("g", {
    id: "input_12_f3"
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 530.615,
    y: 2639.39,
    width: 43.0822,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "1,500_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 553.781,
    y: 2649.37
  }, "1,500")))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 397_2_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_5_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "LTC & LTARV_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2668.95
  }, "LTC & LTARV")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 399_3_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_13_f3"
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 523.948,
    y: 2658.97,
    width: 20,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "91.10%_2_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 523.948,
    y: 2668.95
  }, "91.10%")))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line 2_2_f3",
    d: "M547.864 2662.89V2670.72",
    stroke: "#CBDCC3",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "input_14_f3"
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 551.781,
    y: 2658.97,
    width: 21.9166,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "74.9%_2_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 551.781,
    y: 2668.95
  }, "74.9%")))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 400_2_f3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-240-inside-9_11512_2147_f3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.14 2678.55H573.697V2682.55H365.14V2678.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M365.14 2678.55V2679.55H573.697V2678.55V2677.55H365.14V2678.55Z",
    fill: "#E7F0E2",
    mask: "url(#path-240-inside-9_11512_2147_f3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 399_4_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_6_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Fees_f3",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.14,
    y: 2692.62
  }, "Fees")))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 399_5_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_15_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.864,
    y: 2682.64,
    width: 20,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "input_16_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.781,
    y: 2682.64,
    width: 21.9166,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_7_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 396_6_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_8_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter1_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.057,
    y: 2699.77,
    width: 25.6454,
    height: 12.8957,
    rx: 2.93742,
    fill: "#E7F0E2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 167_f3",
    filter: "url(#filter38_d_11512_2147_f3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.38,
    y: 2700.26,
    width: 11.8331,
    height: 11.9166,
    rx: 1.95828,
    fill: "white",
    shapeRendering: "crispEdges"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 400_3_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_17_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.782,
    y: 2698.39,
    width: 18,
    height: 15.6663,
    rx: 1.95828,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 2_3_f3",
    d: "M526.698 2702.3V2710.14",
    stroke: "#CBDCC3",
    strokeWidth: 0.489571
  }), /*#__PURE__*/React.createElement("g", {
    id: "input_18_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.86,
    y: 2698.63,
    width: 42.5926,
    height: 15.1767,
    rx: 1.7135,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.86,
    y: 2698.63,
    width: 42.5926,
    height: 15.1767,
    rx: 1.7135,
    stroke: "#CBDCC3",
    strokeWidth: 0.489571
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "financing-expanded_2_f3"
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 593.526,
    y: 2518.05,
    width: 231.567,
    height: 242.337,
    rx: 3.67178,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 593.526,
    y: 2518.05,
    width: 231.567,
    height: 242.337,
    rx: 3.67178,
    stroke: "#DAE4D5",
    strokeWidth: 0.489571
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 310_4_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 337_2_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Flip Summary_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.83313,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2536.09
  }, "Flip Summary"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 402_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 400_4_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_9_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 397_3_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_10_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ARV_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2559.12
  }, "ARV"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 400_5_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_11_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Purchase Price_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2578.7
  }, "Purchase Price"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 401_2_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_12_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Rehab Costs_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2598.28
  }, "Rehab Costs"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 399_6_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_13_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Closing Costs_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2617.87
  }, "Closing Costs"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 403_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_14_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Holding Costs_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2637.45
  }, "Holding Costs"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 404_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_15_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Selling Costs_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2657.03
  }, "Selling Costs"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 405_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_16_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Total Expenses_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2676.62
  }, "Total Expenses"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 406_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 398_17_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Net Profit_2_f3",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.36442,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 605.031,
    y: 2696.2
  }, "Net Profit"))))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207 -2391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 31_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 28_f3",
    filter: "url(#filter39_d_11512_2147_f3)",
    "data-figma-bg-blur-radius": 4
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 2596,
    width: 165,
    height: 131,
    rx: 24,
    fill: "white",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 389.25,
    y: 2596.25,
    width: 164.5,
    height: 130.5,
    rx: 23.75,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 27_3_f3",
    filter: "url(#filter40_d_11512_2147_f3)"
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 2608,
    width: 141,
    height: 107,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Templates_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 449,
    y: 2625.77
  }, "Templates"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 243_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 648_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 247_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 239_f3"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "input_19_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.249,
    y: 2638.25,
    width: 9.47093,
    height: 9.47093,
    rx: 4.73547,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.249,
    y: 2638.25,
    width: 9.47093,
    height: 9.47093,
    rx: 4.73547,
    stroke: "#CBDCC3",
    strokeWidth: 0.49847
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Cash - Template #1_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.97858,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 428.957,
    y: 2645.41
  }, "Cash - Template #1")))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 653_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-dots-vertical_f3",
    clipPath: "url(#clip12_11512_2147_f3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7_f3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.678 2640.11C526.678 2640.47 526.38 2640.77 526.013 2640.77C525.646 2640.77 525.349 2640.47 525.349 2640.11C525.349 2639.74 525.646 2639.44 526.013 2639.44C526.38 2639.44 526.678 2639.74 526.678 2640.11ZM526.678 2642.99C526.678 2643.35 526.38 2643.65 526.013 2643.65C525.646 2643.65 525.349 2643.35 525.349 2642.99C525.349 2642.62 525.646 2642.32 526.013 2642.32C526.38 2642.32 526.678 2642.62 526.678 2642.99ZM526.013 2646.53C526.38 2646.53 526.678 2646.23 526.678 2645.87C526.678 2645.5 526.38 2645.2 526.013 2645.2C525.646 2645.2 525.349 2645.5 525.349 2645.87C525.349 2646.23 525.646 2646.53 526.013 2646.53Z",
    fill: "#4F5F4A"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 248_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 239_2_f3"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "input_20_f3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.249,
    y: 2658.23,
    width: 9.47093,
    height: 9.47093,
    rx: 4.73547,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.249,
    y: 2658.23,
    width: 9.47093,
    height: 9.47093,
    rx: 4.73547,
    stroke: "#CBDCC3",
    strokeWidth: 0.49847
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 799_f3",
    cx: 419.985,
    cy: 2662.96,
    r: 2.49235,
    fill: "#4CBC18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 624_f3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Loan - Template #2_f3",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.97858,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 428.957,
    y: 2665.39
  }, "Loan - Template #2"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 623_f3"
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 491.951,
    y: 2659.47,
    width: 25.9878,
    height: 6.99388,
    rx: 0.99694,
    fill: "#4CBC18"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Default_f3",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 4.9847,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 493.945,
    y: 2664.7
  }, "DEFAULT")))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 654_f3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-dots-vertical_2_f3",
    clipPath: "url(#clip13_11512_2147_f3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8_f3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.678 2660.08C526.678 2660.45 526.38 2660.75 526.013 2660.75C525.646 2660.75 525.349 2660.45 525.349 2660.08C525.349 2659.71 525.646 2659.42 526.013 2659.42C526.38 2659.42 526.678 2659.71 526.678 2660.08ZM526.678 2662.96C526.678 2663.33 526.38 2663.63 526.013 2663.63C525.646 2663.63 525.349 2663.33 525.349 2662.96C525.349 2662.59 525.646 2662.3 526.013 2662.3C526.38 2662.3 526.678 2662.59 526.678 2662.96ZM526.013 2666.51C526.38 2666.51 526.678 2666.21 526.678 2665.84C526.678 2665.47 526.38 2665.18 526.013 2665.18C525.646 2665.18 525.349 2665.47 525.349 2665.84C525.349 2666.21 525.646 2666.51 526.013 2666.51Z",
    fill: "#4F5F4A"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "btn_3_f3",
    filter: "url(#filter41_d_11512_2147_f3)"
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 2677,
    width: 60,
    height: 22,
    rx: 11,
    fill: "#4CBC18",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Import_f3",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8.99578,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 456.999,
    y: 2690.95
  }, "Import")))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_9_f3",
    filter: "url(#filter42_d_11512_2147_f3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502 2700.76C501.995 2701.01 501.905 2701.26 501.743 2701.46C501.58 2701.66 501.354 2701.81 501.096 2701.89L495.328 2703.52C495.027 2703.6 494.754 2703.76 494.532 2703.97C494.31 2704.17 494.146 2704.43 494.055 2704.72L492.323 2710.15C492.245 2710.39 492.087 2710.6 491.872 2710.76C491.657 2710.91 491.396 2711 491.126 2711C490.856 2711.01 490.59 2710.93 490.367 2710.79C490.144 2710.65 489.975 2710.44 489.885 2710.2L485.065 2696.58C484.991 2696.37 484.98 2696.14 485.034 2695.92C485.088 2695.71 485.206 2695.51 485.373 2695.35C485.54 2695.19 485.751 2695.08 485.981 2695.03C486.211 2694.98 486.452 2694.99 486.676 2695.06L501.14 2699.6C501.395 2699.68 501.616 2699.84 501.77 2700.05C501.925 2700.26 502.005 2700.5 502 2700.76Z",
    fill: "#17270D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.089 2695.52C486.234 2695.49 486.386 2695.49 486.526 2695.54L500.99 2700.08C501.148 2700.13 501.28 2700.23 501.369 2700.35C501.459 2700.47 501.503 2700.61 501.5 2700.75V2700.75C501.497 2700.89 501.447 2701.03 501.353 2701.15C501.281 2701.24 501.186 2701.31 501.075 2701.36L500.959 2701.4L495.191 2703.04H495.19C494.815 2703.14 494.47 2703.34 494.188 2703.6C493.907 2703.87 493.697 2704.2 493.579 2704.56L493.578 2704.56L491.847 2710C491.803 2710.13 491.712 2710.26 491.582 2710.35C491.451 2710.44 491.289 2710.5 491.118 2710.5L491.11 2710.5C490.94 2710.51 490.774 2710.46 490.638 2710.37C490.502 2710.28 490.404 2710.16 490.353 2710.03L485.537 2696.41C485.495 2696.29 485.489 2696.17 485.52 2696.04C485.55 2695.92 485.616 2695.81 485.716 2695.71C485.816 2695.62 485.944 2695.55 486.089 2695.52Z",
    stroke: "#F4FAEF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature-3.4e05d2e8fb5a8ba86fbb90bdf6b0b3fe.svg";
export { ForwardRef as ReactComponent };